import Vue from 'vue'
import Router from 'vue-router'
import { navigationRoutes, findRouteByPath } from '@/routes/navigationRoutes'
import { isUserLogged, getSelectedLanguage, getUserRole } from '@/services/authService'
import { devLog } from '@/utils/environment'

import BaseLayout from '@/layouts/BaseLayout'


Vue.use(Router)

export const router = new Router({
  mode: 'hash',
  base: '/',
  routes : [{
    path: '/:lang/',
    name: 'BaseLayout',
    component: BaseLayout,
    children: navigationRoutes
  }], scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

const ALLOWED_LANG = [
  "en",
  "es"
]

router.beforeEach((to, from, next) => {
  devLog("Route FROM:", from.path)
  devLog("Route TO:", to.path)

  const LOGGED = isUserLogged()
  const HOME_ROUTE = LOGGED ? `/${getSelectedLanguage()}/active-repairs` : `/${getSelectedLanguage()}/login`

  // NOTE:
  // if /utm_source/ is set, means the url comes from Gmail (in this case), so if the user is not logged in the system when this routing is executing
  // then store the href of the request as query parameter /redirect_to/ as base 64 value.
  // When user is about to log in, check if there is /redirect_to/ query param, and if so, redirect to that url.
  const UTM_SOURCE_QUERY = to.query['utm_source']
  const REDIRECT_TO = UTM_SOURCE_QUERY !== undefined ? btoa(to.path) : null
  const SET_REDIRECT_QUERY = REDIRECT_TO !== null && REDIRECT_TO !== undefined

  if(to.params.lang === undefined) {
    devLog("Route has NOT been specified! | Lang not found!")
    next({
      path: HOME_ROUTE,
      query: SET_REDIRECT_QUERY ? {
        "redirect_to": REDIRECT_TO,
        "utm_source": UTM_SOURCE_QUERY
      } : {}
    })
  }
  else if(!ALLOWED_LANG.includes(to.params.lang)) {
    devLog("Valid language has NOT been specified!")
    next({
      path: HOME_ROUTE,
      query: SET_REDIRECT_QUERY ? {
        "redirect_to": REDIRECT_TO,
        "utm_source": UTM_SOURCE_QUERY
      } : {}
    })
  }
  else if (new RegExp(/^\/\w{2}\/?$/).test(to.path)) {
    devLog("Language specified only. | Redirect to [HOME*]...")
    next({
      path: HOME_ROUTE,
      query: SET_REDIRECT_QUERY ? {
        "redirect_to": REDIRECT_TO,
        "utm_source": UTM_SOURCE_QUERY
      } : {}
    })
  }
  else {
    const ROUTE_TO = findRouteByPath(to.path)
    
    if (!ROUTE_TO) {
      devLog("Route has NOT been specified! | Route object not found!")
      next({
        path: HOME_ROUTE,
        query: SET_REDIRECT_QUERY ? {
          "redirect_to": REDIRECT_TO,
          "utm_source": UTM_SOURCE_QUERY
        } : {}
      })
      return
    }

    devLog(`Required permissions for page [${ROUTE_TO.name}/${ROUTE_TO.path}]:`, ROUTE_TO.permissions)
    devLog("Checking if you can access it...")

    if (LOGGED) {
      if (ROUTE_TO.permissions.includes(getUserRole())) {
        devLog("***Access GRANTED.")
        next(true)
      }
      else {
        devLog("***Access DENIED! | Redirect to [HOME*]...")
        next(HOME_ROUTE)
      }
    }
    else {
      if (ROUTE_TO.permissions.length === 0) {
        devLog("***Access GRANTED.")
        next(true)
      }
      else {
        devLog("***Access DENIED! | Redirect to [HOME*]...")
        next({
          path: HOME_ROUTE,
          query: SET_REDIRECT_QUERY ? {
            "redirect_to": REDIRECT_TO,
            "utm_source": UTM_SOURCE_QUERY
          } : {}
        })
      }
    }
  }
})
